import { render, staticRenderFns } from "./InternalProductComponent.vue?vue&type=template&id=6154d569"
import script from "./InternalProductComponent.vue?vue&type=script&lang=js"
export * from "./InternalProductComponent.vue?vue&type=script&lang=js"
import style0 from "./InternalProductComponent.vue?vue&type=style&index=0&id=6154d569&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports